import companyCover from '../../../assets/images/library-company.svg';
import esopsCover from '../../../assets/images/library-esops.svg';
import fundraisingCover from '../../../assets/images/library-fundraising.svg';
import operationsCover from '../../../assets/images/library-operations.svg';
import defaultCover from '../../../assets/images/library-other.svg';

export const LIBRARY_RESOURCE_CATEGORY = {
  Company: 'Company',
  ESOPs: 'ESOPs',
  Fundraising: 'Fundraising',
  Operations: 'Operations',
} as const;

export type LibraryResourceCategory =
  (typeof LIBRARY_RESOURCE_CATEGORY)[keyof typeof LIBRARY_RESOURCE_CATEGORY];

const COVER_BY_CATEGORY: Record<LibraryResourceCategory, string> = {
  Company: companyCover,
  ESOPs: esopsCover,
  Fundraising: fundraisingCover,
  Operations: operationsCover,
};

const isLibraryResourceCategory = (category: string): category is LibraryResourceCategory =>
  (Object.values(LIBRARY_RESOURCE_CATEGORY) as string[]).includes(category);

export const getLibraryCoverByCategory = (category: string): string =>
  isLibraryResourceCategory(category) ? COVER_BY_CATEGORY[category] : defaultCover;
